import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=3396e6d1&"
var script = {}
import style0 from "./contact.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3396e6d1')) {
      api.createRecord('3396e6d1', component.options)
    } else {
      api.reload('3396e6d1', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=3396e6d1&", function () {
      api.rerender('3396e6d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contact/contact.vue"
export default component.exports